import ApplicationAdapter from 'eflex/adapters/application';

export default class ZebraPrinterAdapter extends ApplicationAdapter {
  pathForType() {
    return 'hardwares';
  }
}
